<template>
  <div
    class="edit-station edit-station-basic-landscape"
  >
    <div class="edit-station-basic-landscape__column">
      <select-element
        :title="'Plant Type'"
        :value="computedPlantType"
        :list="computedPlantTypes"
        :emit-function-named="'setStationPlantType'"
        @setStationPlantType="setStationPlantType"
      />
    </div>
    <div class="edit-station-basic-landscape__column">
      <select-element
        :title="'Soil Type'"
        :value="computedSoilType"
        :list="computedSoilTypes"
        :mad="computedSoilTypes"
        :emit-function-named="'setStationSoilType'"
        @setStationSoilType="setStationSoilType"
      />
    </div>
    <div class="edit-station-basic-landscape__column">
      <select-element
        :title="'Slope %'"
        :value="computedSlopeType"
        :list="slopeTypes"
        :emit-function-named="'setStationSlope'"
        @setStationSlope="setStationSlope"
      />
    </div>
    <div class="edit-station-basic-landscape__column">
      <div class="edit-station-basic-landscape__title">
        Root Depth: {{ convertUnits(station.actRootDepth / 100, 'in', 'cm') + getDenominator('centimetre', 'inch', 0) }} 
      </div>
    </div>
  </div>
</template>

<script>
import{SocketHandler, LifeCycle, MicroService, UnitSystem} from'@/assets/javascript/mixins/Mixins'
import {lowerCaseObject} from '@/assets/javascript/utilities'

import InputElement from'@/components/elements/InputElement.vue'
import SelectElement from'@/components/elements/SelectElementReactive.vue'

export default {
  name: 'EditBasicLandscapeParameters',
  components: {
    'select-element': SelectElement
  },
  mixins: [SocketHandler, LifeCycle, MicroService, UnitSystem],
  props: {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    station: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      plantTypes: null,
      soilTypes: null,
      rootDepths: null,
      slopeTypes:  [
        {value: '10', label: 'Flat (0-3%)'},
        {value: '20', label: 'Gentle (4-6%)'},
        {value: '30', label: 'Medium (7-12%)'},
        {value: '40', label: 'Steep (>13%)'}
      ]
    }
  },
  computed: {
    // plant
    computedPlantType() {
      return this.findValueInArray(this.computedPlantTypes, this.station.plantType)
    },
    computedPlantTypes() {
      return this.plantTypes
      ? this.plantTypes.map((plantType) => ({value: plantType.id, label: plantType.name, rootDepth: plantType.rootdepth})).sort((a, b) => (parseInt(a.value) > parseInt(b.value)) ? 1 : -1)
      : null
    },
    // soil type
    computedSoilType() {
      return this.findValueInArray(this.computedSoilTypes, this.station.soilType)
    },
    computedSoilTypes() {
      return this.soilTypes
      ? this.soilTypes.map((soilType) => ({value: soilType.soiltype, label: soilType.soilname, mad: soilType.default_mad})).sort((a, b) => (a.soilType > b.soilType) ? 1 : -1)
      : null
    },
    // slope
    computedSlopeType() {
      return this.findValueInArray(this.slopeTypes, this.station.slope)
    }
  },
  created() {
    this.request('api/auth/decoders/planttypes', 'plantTypes')
    this.request('api/auth/decoders/soilMoisture', 'soilTypes')
  },
  mounted() {
  },
  methods: {
    findValueInArray: (ary, item) => ary && item
      ? ary.find(cur => cur.value === item).value
      : null
    ,
    updateStation(fields) {
      this.SocketMessageSend(
        Object.assign({}, {
          Category: 'Stations',
          Type: 'StationData',
          Oper: 'Upd',
          Seq: this.station.decId
        },
        lowerCaseObject(fields))
      )

      Object.keys(fields).forEach(key=> this.$set(this.station, key, '' +  fields[key])) // @TODO: Should be done with return data when ready
    },
    setStationPlantType(val) {
      this.updateStation({plantType: val.value, actRootDepth: val.rootDepth})//, rootdepth: val.rootDepth})
      this.station.actRootDepth = val.rootDepth
    },
    setStationSoilType(val) {

      this.updateStation({soilType: val.value, mad: val.mad})
    },
    setStationSlope(val) {
      this.updateStation({slope: val.value})
    },
    request(path, pointerString) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: path
      })
      .then((response) => {
        if(response.data && response.data.length) {
          response.data.pop()
          this.$set(this, pointerString, response.data)
        } else {
          console.error(response)
        }
      }).catch(console.error)
    }
  }
}
</script>

<style lang="scss">
  .edit-station-basic-landscape {

    &__title {
      padding: 5px;
      margin: 5px;
      font-size: 14px;
      font-family: 'Montserrat-SemiBold';
      font-weight: normal;
    }
  }
</style>
